(function () {
  'use strict';

  function hydrate(img) {
    if (!img || !img.dataset) return;
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      img.removeAttribute('data-srcset');
    }
    if (img.dataset.src) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    }
  }

  function whenReady(img) {
    if (!img || (img.complete && img.naturalWidth > 0)) return Promise.resolve();
    if (typeof img.decode === 'function') {
      return img.decode().catch(function () {});
    }
    return new Promise(function (resolve) {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    });
  }

  function init(root) {
    if (!root || root.dataset.colorwaysReady === 'true') return;
    root.dataset.colorwaysReady = 'true';

    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-colorways-swatch]'));
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-colorways-image]'));
    var details = Array.prototype.slice.call(root.querySelectorAll('[data-colorways-detail]'));
    if (!swatches.length) return;

    var current = 0;
    var token = 0;
    const card = root.querySelector('.custom__colorways--card');
    let shown = 0;

    function imagesFor(index) {
      return images
        .filter(function (el) { return el.dataset.index === String(index); })
        .map(function (el) { return el.querySelector('img'); })
        .filter(Boolean);
    }

    function hydrateIndex(index) {
      imagesFor(index).forEach(function (img) {
        img.loading = 'eager';
        hydrate(img);
      });
    }

    /**
     * Slides the shown colourway's renders out and the given colourway's renders in.
     * The direction follows the swatch order (later swatch: from the right).
     * @param {number} index - Colourway to show.
     */
    function showImages(index) {
      if (index === shown) {
        return;
      }

      card.dataset.direction = index > shown ? 'next' : 'prev';
      images.forEach((el) => el.classList.remove('is-leaving'));

      // Apply the new direction before the classes change, so the entering renders start on the correct side
      void card.offsetWidth;

      images.forEach((el) => {
        el.classList.toggle('is-active', el.dataset.index === String(index));
        el.classList.toggle('is-leaving', el.dataset.index === String(shown));
      });
      shown = index;
    }

    function select(index, focus) {
      if (index < 0 || index >= swatches.length) return;
      current = index;
      var myToken = ++token;

      swatches.forEach(function (btn, i) {
        var active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
        btn.setAttribute('tabindex', active ? '0' : '-1');
      });
      if (focus) swatches[index].focus();

      details.forEach(function (el) {
        var active = el.dataset.index === String(index);
        el.classList.toggle('is-active', active);
        if (active) {
          el.removeAttribute('aria-hidden');
        } else {
          el.setAttribute('aria-hidden', 'true');
        }
      });

      /* Slide the renders once the new ones are decoded, so the slide never shows an empty frame */
      hydrateIndex(index);
      var wait = Promise.all(imagesFor(index).map(whenReady));
      var timeout = new Promise(function (resolve) { setTimeout(resolve, 2500); });
      Promise.race([wait, timeout]).then(function () {
        if (myToken === token) showImages(index);
      });
    }

    swatches.forEach(function (btn, i) {
      btn.addEventListener('click', function () { select(i, false); });
      /* Start fetching a colourway's renders as soon as the visitor shows intent */
      btn.addEventListener('pointerenter', function () { hydrateIndex(i); });
      btn.addEventListener('focus', function () { hydrateIndex(i); });
      btn.addEventListener('keydown', function (event) {
        var next = null;
        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = (current + 1) % swatches.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = (current - 1 + swatches.length) % swatches.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = swatches.length - 1;
            break;
          case ' ':
          case 'Enter':
            next = i;
            break;
          default:
            return;
        }
        event.preventDefault();
        select(next, true);
      });
    });

    /* Theme editor: selecting a block previews that colourway */
    root.addEventListener('shopify:block:select', function (event) {
      var i = swatches.indexOf(event.target);
      if (i > -1) select(i, false);
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-colorways]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
